export enum ButtonColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum ButtonCustomIcon {
  TRANSFER = 'transfer',
  DISTRIBUTE = 'distribute',
  SEND = 'send',
  TREND_UP = 'trend-up',
  SEND_STOCK = 'send-stock',
}

export enum ButtonTextPosition {
  IN = 'in',
  OUT = 'out',
}

export enum ButtonIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface ButtonConfig {
  text: string;
  color: ButtonColor;
  size: ButtonSize;
  textPosition: ButtonTextPosition;
  click: (event?: Event) => void;
  show?: () => boolean;
  icon?: string | ButtonCustomIcon;
}
